module.exports = __webpack_public_path__ + "static/media/entrance-mini-compound-new.e3abbd3b.webp";